import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class StockComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) {
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

       // Debounce search.
    this.productSearchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.SearchTerm = value;

        if(this.SearchTerm?.length > 2){
          this.SearchIndustryProducts();
        }
      });

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetFilteredBulkStockOffers();
        }
      });

        // Debounce search.
     this.partnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.Filter.SearchTerm = value;
          this.GetPartnersFiltered();
        }
      });

       // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value);
        }
      });

         // Debounce search.
     this.warehouseSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetWarehousesFiltered(value);
        }
      });

     // Debounce stock partner filter search.
     this.stockPartnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetStockFilterPartnersFiltered(value);
        }
      });
   }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  brandSearchTermUpdate = new Subject<string>();
  warehouseSearchTermUpdate = new Subject<string>();
  partnerSearchTermUpdate = new Subject<string>();
  productSearchTermUpdate = new Subject<string>();
  stockPartnerSearchTermUpdate = new Subject<string>();

  SearchTerm:string;
  StockFilterPartners:any[];
  StockFilterPartnerName:string;

  //for gallery objetcs
  StockProducts:any[];
  FilteredStockOffers:any[];
  SearchedProducts:any[];

  Filter: {[k: string]: any} = {};
  Totals: any[];
  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  
  Periods:any[];
  Updaters:any[];
  FilterLoading:boolean;
  Companies:{[k: string]: any} = [];
  CurrentStock:{[k: string]: any} = {};
  Currencies:{[k: string]: any} = [];

  ProductBoxStatuses:{[k: string]: any} = [];
  ProductConditionStatuses:{[k: string]: any} = [];
  ProductManufacturingStatuses:{[k: string]: any} = [];
  ProductVersionStatuses:{[k: string]: any} = [];
  Countries:{[k: string]: any} = [];
  WeightMeasurementTypes:{[k: string]: any} = [];
  LeadTimeTypes:{[k: string]: any} = [];
  ExportIndustryProductsStockValuesTypes:{[k: string]: any} = [];
  ExportIndustryProductsStockValuesType:any;
  CombineWarehousesQuantityOnExport:boolean = true;

  ExportOnlyUIData:boolean = false;

  Languages:{[k: string]: any} = [];
  ExportLanguage:any;

  // Dropdown toggle states for modern custom dropdowns
  ShowLeadTimeTypeDropdown:boolean = false;
  ShowConditionStatusDropdown:boolean = false;
  ShowBoxStatusDropdown:boolean = false;
  ShowCurrencyDropdown:boolean = false;

  // Tab state
  SelectedStockTab: string = 'Stock-Products';

  // Added Offers tab data
  AddedOffersProducts: any[];
  AddedOffersFilter: {[k: string]: any} = {};

  ShowFilter:boolean;
  StockLoading:boolean = false;
  ExportLoading:boolean = false;

  ngOnInit(): void {
    this.InitializeFilter();
    this.GetIndustryProductsMasterData();
    this.ShowFilter = false;

    // Debounce warehouse search for Add New Zone popup
    this.zoneWarehouseSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value?.length >= 1) {
        this.GetZoneWarehousesFiltered(value);
      }
    });
  }

  CloseOverlay(){
    this.StockProducts = [];
    this.ShowFilter = false;
    this.SearchTerm = "";
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  GetIndustryProductsMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.StockLoading = true;
 
  this.managementService.GetIndustryProductsMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Periods = response["Periods"];
     this.Companies = response["Companies"];
     this.ProductBoxStatuses = response["ProductBoxStatuses"];
     this.ProductConditionStatuses = response["ProductConditionStatuses"];
     this.ProductManufacturingStatuses = response["ProductManufacturingStatuses"];
     this.ProductVersionStatuses = response["ProductVersionStatuses"];
     this.WeightMeasurementTypes = response["WeightMeasurementTypes"];
     this.LeadTimeTypes = response["LeadTimeTypes"];
     this.Currencies = response["Currencies"];
     this.ExportIndustryProductsStockValuesTypes = response["ExportIndustryProductsStockValuesTypes"];
     this.ExportIndustryProductsStockValuesType = this.ExportIndustryProductsStockValuesTypes[0];
     this.Languages = response["Languages"];
     this.ExportLanguage = this.Languages[0];

     this.Countries = response["Countries"];
    }
 
    this.StockLoading = false;

    this.GetFilteredBulkStockOffers();
   });
   }
  
  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.Warehouse = {};
    this.Filter.Warehouse = null;

    this.Filter.Partner = {};
    this.Filter.Partner = null;

    this.Filter.ProductBoxStatus = {};
    this.Filter.ProductBoxStatus = null;

    this.Filter.ProductConditionStatus = {};
    this.Filter.ProductConditionStatus = null;

    this.Filter.ProductManufacturingStatus = {};
    this.Filter.ProductManufacturingStatus = null;

    this.Filter.ProductVersionStatus = {};
    this.Filter.ProductVersionStatus = null;

  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "ProductBoxStatus"){
      this.Filter.ProductBoxStatus = null;
    }
    else if(filterType == "ProductConditionStatus"){
      this.Filter.ProductConditionStatus = null;
    }
    else if(filterType == "ProductManufacturingStatus"){
      this.Filter.ProductManufacturingStatus = null;
    }
    else if(filterType == "ProductVersionStatus"){
      this.Filter.ProductVersionStatus = null;
    }

    this.Filter.Pager.PageIndex = 1;
    this.GetFilteredBulkStockOffers();
  }
  
  GetIndustryProductsStocksFiltered(page = 1){
    this.Filter.Pager.PageIndex = page;  
    
    var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter
      };

      this.StockLoading = true;

      this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.StockProducts = response["StockProducts"];
        }

        this.StockLoading = false;
       });

       this.GetIndustryProductsStocksFilteredCOUNT();
  }

  GetIndustryProductsStocksFilteredCOUNT(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    this.StockLoading = true;

    this.managementService.GetIndustryProductsStocksFilteredCOUNT(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];
      }

      this.StockLoading = false;

     });
}

  GetFilteredBulkStockOffers(page = null){
    if(page != null){
      this.Filter.Pager.PageIndex = page;
    }

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      BrandID: this.Filter.Brand?.ID || null,
      SearchTerm: this.Filter.SearchTerm || null,
      PartnerID: this.Filter.Partner?.ID || null,
      Pager: this.Filter.Pager
    };

    this.StockLoading = true;

    this.managementService.GetFilteredBulkStockOffers(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.FilteredStockOffers = response["StockOffers"];
        this.Filter.Pager = response["Pager"];
      }

      this.StockLoading = false;
    });
  }

  Brands:any[];
  FilterBrandName:string;

  ClearSearchBrand(){

    this.Filter.Brand = null;
    this.Brands = [];
    this.FilterBrandName = null;
    this.GetFilteredBulkStockOffers();
   }

   GetBrandsFiltered(searchTerm:string){

    var BrandFilter = {
      SearchTerm:searchTerm,
      Pager:this.Filter.Pager,
      Company:this.parent.Company
    };

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];

         if(this.Brands.length == 1){
          this.Filter.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.FilterBrandName = this.Filter.Brand.Name;
          this.Brands = [];
          this.GetFilteredBulkStockOffers();
         }
        }
       });
   }

   GetStockFilterPartnersFiltered(searchTerm: string){
    var request = {
      SearchTerm: searchTerm,
      PageIndex: 1,
      PageSize: 20,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: this.parent.Company?.ID
    };

    this.service.GetPartnersFiltered(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.StockFilterPartners = response["Partners"];

        if(this.StockFilterPartners.length == 1){
          this.Filter.Partner = JSON.parse(JSON.stringify(this.StockFilterPartners[0]));
          this.StockFilterPartnerName = this.Filter.Partner.Name;
          this.StockFilterPartners = [];
          this.GetFilteredBulkStockOffers(1);
        }
      }
    });
   }

   InitializeStockFilterPartners(){
    if(this.StockFilterPartners == null || this.StockFilterPartners.length == 0){
      this.GetStockFilterPartnersFiltered("");
    }
   }

   ClearStockFilterPartner(){
    this.Filter.Partner = null;
    this.StockFilterPartners = [];
    this.StockFilterPartnerName = null;
    this.GetFilteredBulkStockOffers(1);
   }

   Warehouses:any[];
   FilterWarehouseName:string;

   GetWarehousesFiltered(searchTerm:string){
    var WHFilter = {
      SearchTerm:searchTerm,
      Pager:this.Filter.Pager,
      Company:this.parent.Company
    };
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:WHFilter
      };

      this.service.GetWarehousesFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Warehouses = response["Warehouses"];
    
         if(this.Warehouses.length == 1){
          this.Filter.Warehouse = JSON.parse(JSON.stringify(this.Warehouses[0]));
          this.FilterWarehouseName = this.Filter.Warehouse.Name;
          this.Warehouses = [];
          this.Filter.Pager.PageIndex = 1;
          this.GetFilteredBulkStockOffers();
         }
        }
       });
   }

   ClearSearchWarehouse(){
    this.Filter.Warehouse = null;
    this.Warehouses = [];
    this.FilterWarehouseName = null;
    this.Filter.Pager.PageIndex = 1;
    this.GetFilteredBulkStockOffers();
    this.ConfigurationWarehouseName = "";
   }

   ClearSearchWarehousePop(){
    this.ConfigurationWarehouseName = "";

    this.Configuration =  null;
    this.ListPriceOffer.Configuration = this.Configuration;
    this.ConfigurationWarehouseName = this.Configuration.Warehouse?.Name;
    this.NewProduct[0].ListPriceOffer = JSON.parse(JSON.stringify(this.ListPriceOffer));
   }

   InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("");
    }
  }

  InitializeWarehouses(){
    if(this.Warehouses == null || this.Warehouses.length == 0){
      this.GetWarehousesFiltered("");
    }
  }

  ShowNewStockEntryContainer:boolean;
  NewProduct:any;
  ListPriceOffer:any;
  ListPriceOfferPartnerName:string;
  ConfigurationWarehouseName:string;
  Partners:any[];
  Configuration:any;

  InitializeNewStockEntry(entry:any = null, CopyProduct:boolean = false){
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        CopyProduct:CopyProduct,
        Product:entry
      };

      this.managementService.InitializeNewStockEntry(request).subscribe(response => {
 
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.ListPriceOffer = JSON.parse(JSON.stringify(response["Product"].ListPriceOffers[0]));
          this.Configuration = this.ListPriceOffer.Configuration;
          this.ConfigurationWarehouseName = this.Configuration.Warehouse?.Name;
          this.ShowNewStockEntryContainer = true;
        }
       });
  }

  CloseDashMenu(){
    this.ShowNewStockEntryContainer = false;
  }

  ClearPartnerBrand(){

    if(this.ListPriceOffer != null){
      this.ListPriceOffer.Partner = {};
    }

    this.Filter.Partner = null;
    this.Partners = [];
    this.ListPriceOfferPartnerName = "";
   }

   InitializePartners(){
    if(this.Partners == null || this.Partners.length == 0){
      this.Filter.Pager.PageIndex = 1;
      this.Filter.SearchTerm = "";
      this.GetPartnersFiltered();
    }
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.Filter.SearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.StockLoading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }
   
      this.StockLoading = false;
    });
  }

  GetWarehouse(id:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      WarehouseID:id
    };
  
    this.service.GetWarehouse(request).subscribe(response => {
  
      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Configuration.Warehouse =  response["Warehouse"];
      }
     });
   }

   GetImportConfigurationByWarehouse(id:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      WarehouseID:id
    };
  
    this.managementService.GetImportConfigurationByWarehouse(request).subscribe(response => {
  
      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Configuration =  response["Configuration"];
        this.ListPriceOffer.Configuration = this.Configuration;
        this.ConfigurationWarehouseName = this.Configuration.Warehouse?.Name;
        this.NewProduct[0].ListPriceOffer = this.ListPriceOffer;
      }
     });
   }

   InitializeSearchProduct(){
    if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
      this.SearchIndustryProducts();
    }
  }

  SearchIndustryProducts(){
    
    var filter = JSON.parse(JSON.stringify(this.Filter));
    filter.SearchTerm = this.SearchTerm;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:filter
    };
  
    this.StockLoading = true;
  
    this.managementService.SearchIndustryProducts(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SearchedProducts = response["SearchResults"];
      }
  
      this.StockLoading = false;
     });
  }

  GetIndustryProductByID(ID:number, withOffers:boolean){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:ID,
      WithListPriceOffers:withOffers
    };
  
    this.StockLoading = true;
  
    this.managementService.GetIndustryProductByID(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var p = response["Product"];
        this.NewProduct = p;
        this.NewProduct.ListPriceOffers = [];
        this.ListPriceOffer.ParentID = JSON.parse(JSON.stringify(this.NewProduct.ID));
        this.NewProduct.ListPriceOffers.push(JSON.parse(JSON.stringify(this.ListPriceOffer)));

        this.SearchedProducts = [];
        this.SearchTerm = "";
      }
  
      this.StockLoading = false;
     });
  }

  ClearSearchIndustryProducts(){
    this.SearchTerm = "";
    this.SearchedProducts = [];
  }

  AddUpdateListPriceOffer(offer:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Offer:offer
    };

    this.StockLoading = true;

    this.managementService.AddUpdateListPriceOffer(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowNewStockEntryContainer = false;

        this.GetFilteredBulkStockOffers();
      }

      this.StockLoading = false;
     });
  }

  SaveSellingPrice(product:any){
    var offer = product.ListPriceOffers[0];

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Offer:offer
    };

    this.StockLoading = true;

    this.managementService.AddUpdateListPriceOffer(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.GetFilteredBulkStockOffers();
      }

      this.StockLoading = false;
    });
  }

  ShowDeleteProductQuestion:boolean;

  PrepareDeleteListPriceOffer(p:any){
    this.ListPriceOffer = p.ListPriceOffers[0];
  }

  DeleteIndustryProductStockOffer(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      OfferID:this.ListPriceOffer.ID
    };
  
    this.StockLoading = true;
  
    this.managementService.DeleteIndustryProductStockOffer(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetFilteredBulkStockOffers();
      }

      this.StockLoading = false;
     });
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }

  ExportIndustryProductsStockValues(){
  
      var request = {
        User:this.parent.User,
        Language:this.ExportLanguage?.Name,
        Filter:this.Filter,
        ExportType:this.ExportIndustryProductsStockValuesType,
        CombineWarehousesQuantityOnExport:this.CombineWarehousesQuantityOnExport,
        ExportOnlyUIData:this.ExportOnlyUIData
      };
     
      this.StockLoading = true;
  
      this.managementService.ExportIndustryProductsStockValues(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.download(Document.Name, Document.PDFStream);
        }
     
        this.StockLoading = false;
      });
  }

  ExportBulkStockValues(){
    if(this.ExportLoading) return;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage()
    };

    this.ExportLoading = true;

    this.managementService.ExportBulkStockValues(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.downloadExcel(Document.Name, Document.PDFStream);
      }

      this.ExportLoading = false;
    });
  }

  downloadExcel(filename: string, base64: string) {
    var byteCharacters = atob(base64);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }

  ShowExportStockQuestion:boolean;

  // === Added Offers Tab Methods ===

  InitializeAddedOffersFilter(){
    this.AddedOffersFilter = {};
    this.AddedOffersFilter.Pager = {};
    this.AddedOffersFilter.Pager.PageIndex = 1;
    this.AddedOffersFilter.Pager.PageSize = 50;
    this.AddedOffersFilter.Pager.TotalCount = 0;
  }

  GetAddedOffersFiltered(page = 1){
    if(!this.AddedOffersFilter.Pager){
      this.InitializeAddedOffersFilter();
    }
    this.AddedOffersFilter.Pager.PageIndex = page;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.AddedOffersFilter
    };
    this.StockLoading = true;
    this.managementService.GetIndustryProductsAddedOffersFiltered(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.AddedOffersProducts = response["StockProducts"];
      }
      this.StockLoading = false;
    });
    this.GetAddedOffersFilteredCOUNT();
  }

  GetAddedOffersFilteredCOUNT(){
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.AddedOffersFilter
    };
    this.StockLoading = true;
    this.managementService.GetIndustryProductsAddedOffersFilteredCOUNT(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.AddedOffersFilter.Pager = response["Pager"];
      }
      this.StockLoading = false;
    });
  }

  OnTabChange(tab: string){
    this.SelectedStockTab = tab;
    if(tab === 'Added-Offers' && (!this.AddedOffersProducts || this.AddedOffersProducts.length === 0)){
      this.InitializeAddedOffersFilter();
      this.GetAddedOffersFiltered();
    }
  }

  SaveAddedOfferSellingPrice(product:any){
    var offer = product.ListPriceOffers[0];
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Offer:offer
    };
    this.StockLoading = true;
    this.managementService.AddUpdateListPriceOffer(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-success-snackbar");
      }
      this.StockLoading = false;
    });
  }

  OnAddedOfferCurrencyChange(product: any, currencyId: number) {
    const selectedCurrency = this.Currencies.find(c => c.ID === currencyId);
    if (selectedCurrency && product.ListPriceOffers?.length > 0) {
      product.ListPriceOffers[0].Currency = selectedCurrency;
    }
  }

  OnStockProductCurrencyChange(cartItem: any, currencyId: number) {
    const selectedCurrency = this.Currencies.find(c => c.ID === currencyId);
    if (selectedCurrency && cartItem.Product?.ListPriceOffers?.length > 0) {
      cartItem.Product.ListPriceOffers[0].Currency = selectedCurrency;
    }
  }

  SaveFilteredStockOfferPrice(cartItem: any) {
    var offer = cartItem.Product?.ListPriceOffers[0];
    if(!offer) return;

    offer.SellingPrice = offer.SellPrice?.UIUnitPrice;
    offer.IsForcedPrice = true;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Offer: offer
    };

    this.StockLoading = true;

    this.managementService.AddUpdateListPriceOffer(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if (response["Status"] == 1) {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.GetFilteredBulkStockOffers();
      }

      this.StockLoading = false;
    });
  }

  // ========== WAREHOUSE ITEM POSITIONS ==========

  ShowPositionsPopup: boolean = false;
  ShowAddEditPositionPopup: boolean = false;
  ShowDeletePositionQuestion: boolean = false;
  ShowAddNewZonePopup: boolean = false;
  CurrentPositionOffer: any;
  WarehouseItemPositions: any[] = [];
  NewPosition: any = {};
  NewWHZone: any = {};
  WHZones: any[] = [];

  // Warehouse selection for Add New Zone
  ZoneWarehouseFilter: any = { SearchTerm: '', Pager: { PageIndex: 1, PageSize: 50, TotalCount: 0 } };
  ZoneWarehouses: any[] = [];
  SelectedZoneWarehouse: any = null;
  zoneWarehouseSearchFocused: boolean = false;
  zoneWarehouseSearchTermUpdate = new Subject<string>();

  OpenPositionsPopup(product: any) {
    this.CurrentPositionOffer = product.ListPriceOffers[0];
    this.ShowPositionsPopup = true;
    this.GetWarehouseItemPositions();
    this.GetWHZonesForPositions();
  }

  ClosePositionsPopup() {
    this.ShowPositionsPopup = false;
    this.CurrentPositionOffer = null;
    this.WarehouseItemPositions = [];
  }

  GetWarehouseItemPositions() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ListPriceOfferID: this.CurrentPositionOffer.ID
    };

    this.StockLoading = true;

    this.managementService.GetWarehouseItemPositions(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        this.WarehouseItemPositions = response["Positions"];
      }
      this.StockLoading = false;
    });
  }

  GetWHZonesForPositions() {
    if (this.CurrentPositionOffer?.Configuration?.Warehouse?.ID) {
      var request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        WarehouseID: this.CurrentPositionOffer.Configuration.Warehouse.ID
      };

      this.service.GetWHZones(request).subscribe(response => {
        if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        } else if (response["Status"] == 1) {
          this.WHZones = response["WHZones"];
        }
      });
    }
  }

  OpenAddNewPosition() {
    this.NewPosition = {
      ID: 0,
      FKListPriceOfferID: this.CurrentPositionOffer.ID,
      Zone: null,
      Row: 1,
      Column: 1,
      Description: '',
      Quantity: 0
    };
    this.ShowAddEditPositionPopup = true;
  }

  OpenEditPosition(position: any) {
    this.NewPosition = JSON.parse(JSON.stringify(position));
    this.ShowAddEditPositionPopup = true;
  }

  CloseAddEditPositionPopup() {
    this.ShowAddEditPositionPopup = false;
    this.NewPosition = {};
  }

  // ✅ New Zone Popup Methods
  OpenAddNewZonePopup() {
    // Pre-select current warehouse if available
    const currentWarehouse = this.CurrentPositionOffer?.Configuration?.Warehouse;
    this.SelectedZoneWarehouse = currentWarehouse ? JSON.parse(JSON.stringify(currentWarehouse)) : null;

    this.NewWHZone = {
      ID: 0,
      Name: '',
      Description: '',
      ParentWarehouseID: currentWarehouse?.ID || null
    };

    // Reset warehouse search state
    this.ZoneWarehouseFilter = { SearchTerm: '', Pager: { PageIndex: 1, PageSize: 50, TotalCount: 0 } };
    this.ZoneWarehouses = [];
    this.zoneWarehouseSearchFocused = false;

    this.ShowAddNewZonePopup = true;
  }

  CloseAddNewZonePopup() {
    this.ShowAddNewZonePopup = false;
    this.NewWHZone = {};
    this.SelectedZoneWarehouse = null;
    this.ZoneWarehouses = [];
    this.ZoneWarehouseFilter.SearchTerm = '';
    this.zoneWarehouseSearchFocused = false;
  }

  GetZoneWarehousesFiltered(searchTerm: string, page: number = 1) {
    this.ZoneWarehouseFilter.Pager.PageIndex = page;
    this.ZoneWarehouseFilter.SearchTerm = searchTerm;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.ZoneWarehouseFilter
    };

    this.service.GetWarehousesFiltered(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        this.ZoneWarehouses = response["Warehouses"];
      }
    });
  }

  SelectZoneWarehouse(warehouse: any) {
    this.SelectedZoneWarehouse = warehouse;
    this.NewWHZone.ParentWarehouseID = warehouse.ID;
    this.ZoneWarehouseFilter.SearchTerm = '';
    this.ZoneWarehouses = [];
    this.zoneWarehouseSearchFocused = false;
  }

  ClearZoneWarehouse() {
    this.SelectedZoneWarehouse = null;
    this.NewWHZone.ParentWarehouseID = null;
    this.ZoneWarehouseFilter.SearchTerm = '';
    this.ZoneWarehouses = [];
  }

  InitializeZoneWarehouses() {
    if (this.ZoneWarehouses == null || this.ZoneWarehouses.length == 0) {
      this.GetZoneWarehousesFiltered('', 1);
    }
  }

  AddNewWHZone() {
    // Validate warehouse selection
    if (!this.NewWHZone.ParentWarehouseID) {
      this.parent.openSnackBar(this.translate.instant('Configuration.WarehouseRequired'), 'OK', 'alert-info-snackbar');
      return;
    }

    if (!this.NewWHZone.Name || this.NewWHZone.Name.trim() === '') {
      this.parent.openSnackBar(this.translate.instant('Configuration.ZoneNameRequired'), 'OK', 'alert-info-snackbar');
      return;
    }

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      WHZone: this.NewWHZone
    };

    this.StockLoading = true;

    this.service.AddUpdateWHZone(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

        // Add new zone to the list
        const newZone = response["WHZone"];
        this.WHZones.push(newZone);

        // Auto-select the newly created zone in the dropdown
        this.NewPosition.Zone = newZone;

        // Close the Add New Zone popup
        this.ShowAddNewZonePopup = false;
        this.NewWHZone = {};
        this.SelectedZoneWarehouse = null;
      }

      this.StockLoading = false;
    });
  }

  AddUpdateWarehouseItemPosition(position: any) {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Position: position
    };

    this.StockLoading = true;

    this.managementService.AddUpdateWarehouseItemPosition(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

        if (position.ID == 0) {
          this.WarehouseItemPositions.push(response["Position"]);
        } else {
          const index = this.WarehouseItemPositions.findIndex(p => p.ID === position.ID);
          if (index > -1) {
            this.WarehouseItemPositions[index] = response["Position"];
          }
        }
        this.NewPosition = {};
        this.ShowAddEditPositionPopup = false;
      }

      this.StockLoading = false;
    });
  }

  PrepareDeletePosition(position: any) {
    this.NewPosition = position;
    this.ShowDeletePositionQuestion = true;
  }

  DeleteWarehouseItemPosition() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ID: this.NewPosition.ID
    };

    this.StockLoading = true;

    this.managementService.DeleteWarehouseItemPosition(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        this.WarehouseItemPositions = this.WarehouseItemPositions.filter(x => x.ID != this.NewPosition.ID);
        this.NewPosition = {};
      }

      this.StockLoading = false;
      this.ShowDeletePositionQuestion = false;
    });
  }
}
